// extracted by mini-css-extract-plugin
export default {"component":"style_component__7Iz7D","content":"style_content__wIfn6","bg_main":"style_bg_main__NcRON","bg_top":"style_bg_top__5lyxl"};